/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PostService } from "../../../../Services/ConstantService";
import { API_URL } from "../../../../Services/ApiService";
import {
  showDeleteConfirmation,
  showErrorAlert,
  showSuccessAlert,
} from "../../../../Helper/SweetAlert";
import Switch from "@mui/material/Switch";
import MoonLoader from "react-spinners/MoonLoader";
import Pagination from "../../../../Helper/Pagination";

export default function PriceList() {
  const [PriceList, setpriceList] = useState();
  const [TotalPageCount, SetTotalPageCount] = useState();
  const [TotalCount, SetTotalCount] = useState();
  const [S_No_Count, setCount] = useState(0);
  const [search_key, setsearch_key] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [loading, setLoading] = useState(true);
  const [submitLoader, setsubmitLoader] = useState(false);

  const [selectedData, setSelectedData] = useState("");

  const [AddCustom, setAddCustom] = useState({
    ThinGallery6:'',
    ThinGallery12:'',
    ThinGallery21:'',
    ThinGallery31:'', 
    ThickGallery6:'',
    ThickGallery12:'',
    ThickGallery21:'',
    ThickGallery31:'', 
    Framed6:'',
    Framed12:'',
    Framed21:'',
    Framed31:'', 
    Rolled6:'',
    Rolled12:'',
    Rolled21:'',
    Rolled31:'', 
    Discount:''
  });


  useEffect(() => {
    getpriceList();
  }, [search_key, currentPage]);

  const getpriceList = () => {
    setLoading(true);

    const param = {
      limit: 10,
      page: currentPage,
      sorting: "sortingKey|desc",
      search_key: search_key,
    };

    PostService(API_URL.GET_PRICE_LIST, param).then((res) => {
      console.log(res);
      if (res?.data?.status === true) {
        setpriceList(res.data.data.rows);
        SetTotalPageCount(res.data.totalPages);
        SetTotalCount(res.data.totalItems);
        setCount(res.data.currentPage * param.limit);
        setLoading(false);
      } else {
        showErrorAlert(res.data?.message);
        setLoading(false);
      }
    });
  };

  const [error, setError] = useState(false);

  const [customsize, setcustomSize] = useState("");
  const [thingallerywrap, setthinGalleryWrap] = useState();
  const [thickgallerywrap, setthickGalleryWrap] = useState("");
  const [framed, setFramed] = useState("");
  const [floatingframe, setfloatingframe] = useState();
  const [status, setStatus] = useState("");
  const [discount, setDiscount] = useState("");

  useEffect(() => {
    console.log(selectedData);
    setcustomSize(selectedData?.customsize);
    setthinGalleryWrap(selectedData?.thingallerywrap);
    setthickGalleryWrap(selectedData?.thickgallerywrap);
    setFramed(selectedData?.framed);
    setfloatingframe(selectedData?.floatingframe);
    setStatus(selectedData?.status);
    setDiscount(selectedData?.discount);
  }, [selectedData]);

  const submit = (e) => {
    e.preventDefault();

    if (
      !customsize ||
      !thingallerywrap ||
      !thickgallerywrap ||
      !framed ||
      !floatingframe
    ) {
      setError(true);
      return;
    }

    setsubmitLoader(true);

    let formdata = {
      id: selectedData?.mobilesizeid,
      discount,
      floatingframe,
      framed,
      thickgallerywrap,
      thingallerywrap,
      customsize,
    };

    PostService(API_URL.UPDATE_PRICE_LIST, formdata).then(
      (res) => {
        console.log(res);
        if (res.data.status === true) {
          showSuccessAlert(res?.data?.message, getpriceList);
          resetFunc();
          // getContentList();
          document.getElementById("closeEditModal").click();
        } else {
          showErrorAlert(res.data?.message);
        }
      },
      (err) => {
        showErrorAlert(err.data?.message);
      }
    );
  };

  const changeStatus = async (id, status) => {
    const data = {
      id: id,
      status: status === "Active" ? "Inactive" : "Active",
    };

    PostService(API_URL.CHANGE_PRICE_STATUS, data).then(
      (res) => {
        if (res.data.status) {
          showSuccessAlert(res?.data?.message, getpriceList);
        } else {
          showErrorAlert(res.data?.message);
        }
      },
      (err) => {
        showErrorAlert(err.data?.message);
      }
    );
  };

  const handlePageClick = (e) => {
    setCurrentPage(e - 1);
  };

  function resetFunc() {
    setcustomSize();
    setthinGalleryWrap();
    setthickGalleryWrap();
    setFramed();
    setfloatingframe();
    setStatus();
    setDiscount();
    setError(false);
    setsubmitLoader(false);
  }

  function dataobj(data) {
    console.log(data);
  }
  function Delete(id, name) {
    const data = {
      id: id,
    };

    showDeleteConfirmation(name, () => {
      PostService(API_URL.DELETE_PRODUCT, data).then(
        (res) => {
          if (res.data.status) {
            showSuccessAlert(res?.data?.message, getpriceList);
          } else {
            showErrorAlert(res.data?.message);
          }
        },
        (err) => {
          showErrorAlert(err.data?.message);
        }
      );
    });
  }

  function SetDataValue(value , field){
    const updatedData = { ...AddCustom, [field]: value };
    setAddCustom(updatedData)
  }

  const [Adderror, setAddError] = useState(false);

  function submitAddData(e){
e.preventDefault()
setAddError(true)

console.log(AddCustom)
  }

  function resetAddModal(){
    setAddError(false)
  }

  return (
    <div>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h3 className="default_color">Prices List</h3>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <Link
                  to="/panel/dashboard"
                  className="breadcrumb-item"
                  style={{ textDecoration: "none" }}
                >
                  Dashboard
                </Link>
                <Link className="breadcrumb-item active">Prices List</Link>
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <div className="row align-items-center d-flex justify-content-between">
                    <div className="col-md-4 p-0">
                      <div className="offset-md-1">
                        <button
                          type="submit"
                          className="btn btn-primary"
                          data-toggle="modal"
                          data-target="#AddModal"
                          onClick={() => {
                            resetAddModal();
                          }}
                        >
                          Add Size & Price
                        </button>
                      </div>
                    </div>
                    <div className="col-md-4 p-0">
                      <nav className="navbar">
                        <input
                          type="text"
                          name="firstnamesearch"
                          placeholder="Search by Keyword"
                          className="form-control"
                          autoComplete="off"
                          onChange={(e) => {
                            setTimeout(() => {
                              setsearch_key(e.target.value);
                              setCurrentPage(0);
                            }, 400);
                          }}
                        />
                      </nav>
                    </div>
                  </div>

                  <div className="table-responsive mt-4">
                    {!loading && (
                      <table className="table table-hover table-striped text-nowrap table-bordered">
                        <thead>
                          <tr className="pricelistrow">
                            <th className="text-center">S.No</th>
                            <th className="text-center">Custom Size</th>
                            <th className="text-center">
                              Thin Gallery Wrap($)
                            </th>
                            <th className="text-center">
                              Thick Gallery Wrap($)
                            </th>
                            <th className="text-center">Framed($) </th>
                            <th className="text-center">Rolled in a Tube($)</th>
                            <th className="text-center">Discount</th>
                            <th className="text-center">Status</th>
                            <th className="text-center">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {PriceList?.map((data, i) => (
                            <tr key={i} className="text-center">
                              <td>{i + S_No_Count + 1}</td>
                              <td>
                                {data?.customsize ? data?.customsize : "N/A"}
                              </td>
                              <td>
                                {data?.thingallerywrap
                                  ? data?.thingallerywrap
                                  : "N/A"}
                              </td>
                              <td>
                                {data?.thickgallerywrap
                                  ? data?.thickgallerywrap
                                  : "N/A"}
                              </td>
                              <td>{data?.framed ? data?.framed : "N/A"}</td>
                              <td>
                                {data?.floatingframe
                                  ? data?.floatingframe
                                  : "N/A"}
                              </td>
                              <td>{data?.discount ? data?.discount : "N/A"}</td>
                              <td className="text-center">
                                <span
                                  className={
                                    data?.status === "Active"
                                      ? "badge badge-success"
                                      : "badge badge-danger"
                                  }
                                >
                                  {data?.status}
                                </span>
                              </td>
                              <td className="text-center">
                                <span className="toggle-switch">
                                  <Switch
                                    checked={data?.status === "Active"}
                                    onChange={() => {
                                      changeStatus(
                                        data?.mobilesizeid,
                                        data.status
                                      );
                                    }}
                                    size="small"
                                    color="primary" // You can customize the color
                                    inputProps={{
                                      "aria-label": "toggle switch",
                                    }}
                                  />
                                </span>

                                {/* <Link
                                  title="View"
                                  style={{ cursor: "pointer" }}
                                  className="mx-2"
                                  to={`view/${data?._id}`}
                                >
                                  <i className="text-warning fas fa-eye"></i>
                                </Link> */}
                                <span
                                  title="Update"
                                  style={{ cursor: "pointer" }}
                                  className="mx-2"
                                  data-toggle="modal"
                                  data-target="#EditModal"
                                  onClick={() => {
                                    setSelectedData(data);
                                    dataobj(data);
                                  }}
                                >
                                  <i className="text-dark fas fa-pen"></i>{" "}
                                </span>
                                <span
                                  title="Delete"
                                  style={{ cursor: "pointer" }}
                                  className="mx-2"
                                  onClick={() => {
                                    Delete(data?.mobilesizeid, "Price");
                                  }}
                                >
                                  <i className="text-danger fas fa-trash"></i>{" "}
                                </span>
                              </td>
                            </tr>
                          ))}
                          {PriceList && PriceList.length === 0 && (
                            <tr>
                              <td colSpan="5" className="text-center">
                                <h6 className="p-3"> No Data Found </h6>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    )}
                    {loading ? (
                      <div className="LoaderSpinner">
                        <MoonLoader
                          color={"#003bff"}
                          loading={loading}
                          speedMultiplier={0.6}
                          size={50}
                        />
                        <div>Loading... Please wait.</div>
                      </div>
                    ) : (
                      ""
                    )}

                    <div className="mt-4">
                      <Pagination
                        counting={S_No_Count}
                        totaldata={TotalCount}
                        pagecount={TotalPageCount}
                        onChangePage={handlePageClick}
                        activePage={currentPage}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ---------------- Add Modal Start------------------ */}
      <div
        className="modal fade"
        id="AddModal"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header bg-light">
              <h4 className="modal-title" id="exampleModalLabel">
                Add
              </h4>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                {" "}
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form onSubmit={(e) => submitAddData(e)}>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-12">
                    <table border={0} cellSpacing={0} cellPadding={0}>
                      <tbody>
                        <tr>
                          <td align="left">Custom Size</td>
                          <td align="left">:</td>
                          <td colSpan={4}>
                            <div className=" ">
                            <div style={{ float: "left", width: 469}}>
                              <div style={{ float: "left" ,display:'flex',margin:'10px' }}>
                                <strong>From</strong>&nbsp;:&nbsp;
                                <select
                                  className="form-control"
                                  name="frmcustomsizew"
                                  id="frmcustomsizew"
                                >
                                  <option value="">W</option>
                                  <option value={6}>6"</option>
                                </select>
                                &nbsp;
                              </div>
                              <div style={{ float: "left",marginTop:'10px' }}>
                                <div id="customsize">
                                  <select
                                    className="form-control"
                                    name="frmcustomsizeh"
                                    id="frmcustomsizeh"
                                  >
                                    <option>H</option>
                                    <option value={6}>6"</option>
                                  </select>
                                </div>
                              </div>
                              <div style={{ float: "left" ,display:'flex',margin:'10px' }}>
                                &nbsp;&nbsp;&nbsp;&nbsp;<strong>To</strong>&nbsp;:&nbsp;&nbsp; 
                                <select
                                  className="form-control"
                                  name="tocustomsizew"
                                  id="tocustomsizew"
                                >
                                  <option>W</option>
                                  <option value={40}>40"</option>
                                </select>
                                &nbsp;
                              </div>
                              <div style={{ float: "left",marginTop:'10px' }}>
                                <div id="customsizeto">
                                  <select
                                    className="form-control"
                                    name="tocustomsizeh"
                                    id="tocustomsizeh"
                                  >
                                    <option>H</option>
                                    <option value={60}>60"</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td align="center" valign="middle" height={35}>
                            &nbsp;
                          </td>
                          <td align="center" valign="middle" height={35}>
                            &nbsp;
                          </td>
                          <td align="left" valign="middle" height={35} >
                            <strong className="mt-2">Thin Gallery Wrap</strong>
                          </td>
                          <td align="left" valign="middle" height={35}>
                            <strong>Thick Gallery Wrap</strong>
                          </td>
                          <td align="center" valign="middle" height={35}>
                            <strong>Framed</strong>
                          </td>
                          <td align="center" valign="middle" height={35}>
                            <strong>Rolled in a Tube</strong>
                          </td>
                        </tr>
                        <tr>
                          <td align="left" valign="middle" height={35}>
                            Range from 6"x6" to 11"x14"(per square inch price)
                          </td>
                          <td align="left" valign="middle" height={35}>
                            :
                          </td>
                          <td align="left" valign="middle" height={35}>
                            <input
                              type="text"
                              className="form-control mb-1"
                              style={Adderror && !AddCustom.ThinGallery6 ? { border: '1px solid red' }:{}}
                               value={AddCustom.ThinGallery6}
                              onChange={e=>{SetDataValue(e.target.value,'ThinGallery6')}}
                              size={12}
                            />
                          </td>
                          <td
                            align="left"
                            valign="middle"
                            height={35} 
                          >
                            <input
                              type="text"
                              className="form-control  mb-1"
                               value={AddCustom.ThickGallery6}
                               style={Adderror && !AddCustom.ThickGallery6 ? { border: '1px solid red' }:{}}
                              onChange={e=>{SetDataValue(e.target.value,'ThickGallery6')}}
                              size={12}
                            />
                          </td>
                          <td align="left" valign="middle" height={35}>
                            <input
                              name="framed1"
                              id="framed1"
                              type="text"
                              className="form-control mb-1"
                               value={AddCustom.Framed6}
                               style={Adderror && !AddCustom.Framed6 ? { border: '1px solid red' }:{}}
                              onChange={e=>{SetDataValue(e.target.value,'Framed6')}}
                              size={12}
                            />
                          </td>
                          <td align="center" valign="middle" height={35}>
                            <input
                              name="rolledtube1"
                              id="rolledtube1"
                              type="text"
                              className="form-control mb-1"
                               value={AddCustom.Rolled6}
                               style={Adderror && !AddCustom.Rolled6 ? { border: '1px solid red' }:{}}
                              onChange={e=>{SetDataValue(e.target.value,'Rolled6')}}
                              size={12}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td align="left" valign="middle" height={35}>
                            Range from 12"x15" to 20"x30"(per square inch price)
                          </td>
                          <td align="left" valign="middle" height={35}>
                            :
                          </td>
                          <td align="left" valign="middle" height={35}>
                            <input
                              className="form-control  mb-1"
                              type="text"
                              value={AddCustom.ThinGallery12}
                              style={Adderror && !AddCustom.ThinGallery12 ? { border: '1px solid red' }:{}}
                              onChange={e=>{SetDataValue(e.target.value,'ThinGallery12')}}
                              size={12}
                            />
                          </td>
                          <td align="left" valign="middle" height={35}>
                            <input
                              className="form-control  mb-1"
                              type="text"
                              value={AddCustom.ThickGallery12}
                              style={Adderror && !AddCustom.ThickGallery12 ? { border: '1px solid red' }:{}}
                              onChange={e=>{SetDataValue(e.target.value,'ThickGallery12')}}
                              size={12}
                            />
                          </td>
                          <td align="left" valign="middle" height={35}>
                            <input
                              className="form-control  mb-1"
                              type="text"
                              value={AddCustom.Framed12}
                              style={Adderror && !AddCustom.Framed12 ? { border: '1px solid red' }:{}}
                              onChange={e=>{SetDataValue(e.target.value,'Framed12')}}
                              size={12}
                            />
                          </td>
                          <td align="center" valign="middle" height={35}>
                            <input
                              className="form-control mb-1 "
                              type="text"
                              value={AddCustom.Rolled12}
                              style={Adderror && !AddCustom.Rolled12 ? { border: '1px solid red' }:{}}
                              onChange={e=>{SetDataValue(e.target.value,'Rolled12')}}
                              size={12}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td align="left" valign="middle" height={35}>
                            from 21"x31" to 30"x40"(per square inch price)
                          </td>
                          <td align="left" valign="middle" height={35}>
                            :
                          </td>
                          <td align="left" valign="middle" height={35}>
                            <input
                              className="form-control  mb-1"
                              type="text"
                              value={AddCustom.ThinGallery21}
                              style={Adderror && !AddCustom.ThinGallery21 ? { border: '1px solid red' }:{}}
                              onChange={e=>{SetDataValue(e.target.value,'ThinGallery21')}}
                              size={12}
                            />
                          </td>
                          <td align="left" valign="middle" height={35}>
                            <input
                              className="form-control  mb-1"
                              type="text"
                              value={AddCustom.ThickGallery21}
                              style={Adderror && !AddCustom.ThickGallery21 ? { border: '1px solid red' }:{}}
                              onChange={e=>{SetDataValue(e.target.value,'ThickGallery21')}}
                              size={12}
                            />
                          </td>
                          <td align="left" valign="middle" height={35}>
                            <input
                              className="form-control  mb-1"
                              type="text"
                              value={AddCustom.Framed21}
                              style={Adderror && !AddCustom.Framed21 ? { border: '1px solid red' }:{}}
                              onChange={e=>{SetDataValue(e.target.value,'Framed21')}}
                              size={12}
                            />
                          </td>
                          <td align="center" valign="middle" height={35}>
                            <input
                              className="form-control  mb-1"
                              type="text"
                              value={AddCustom.Rolled21}
                              style={Adderror && !AddCustom.Rolled21 ? { border: '1px solid red' }:{}}
                              onChange={e=>{SetDataValue(e.target.value,'Rolled21')}}
                              size={12}
                            />
                          </td>
                        </tr>
                        <tr className="mb-2">
                          <td align="left" valign="middle" height={35}>
                            from 31"x40" to 40"x60"(per square inch price)
                          </td>
                          <td align="left" valign="middle" height={35}>
                            :
                          </td>
                          <td align="left" valign="middle" height={35} className="mb-2">
                            <input
                              className="form-control  mb-1"
                              type="text"
                              value={AddCustom.ThinGallery31}
                              style={Adderror && !AddCustom.ThinGallery31 ? { border: '1px solid red' }:{}}
                              onChange={e=>{SetDataValue(e.target.value,'ThinGallery31')}}
                              size={12}
                            />
                          </td>
                          <td align="left" valign="middle" height={35}>
                            <input
                              className="form-control  mb-1"
                              type="text"
                              value={AddCustom.ThickGallery31}
                              style={Adderror && !AddCustom.ThickGallery31 ? { border: '1px solid red' }:{}}
                              onChange={e=>{SetDataValue(e.target.value,'ThickGallery31')}}
                              size={12}
                            />
                          </td>
                          <td align="left" valign="middle" height={35}>
                            <input
                              className="form-control  mb-1"
                              type="text"
                              value={AddCustom.Framed31}
                              style={Adderror && !AddCustom.Framed31 ? { border: '1px solid red' }:{}}
                              onChange={e=>{SetDataValue(e.target.value,'Framed31')}}
                              size={12}
                            />
                          </td>
                          <td align="center" valign="middle" height={35}>
                            <input
                              className="form-control  mb-1"
                              type="text"
                              value={AddCustom.Rolled31}
                              style={Adderror && !AddCustom.Rolled31 ? { border: '1px solid red' }:{}}
                              onChange={e=>{SetDataValue(e.target.value,'Rolled31')}}
                              size={12}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td align="left" height={20}>
                            Discount($)
                          </td>
                          <td align="left" height={20}>
                            &nbsp;&nbsp;:&nbsp;&nbsp;
                          </td>
                          <td align="left" height={35} colSpan={2}>
                            <input
                              className="form-control "
                              type="text" 
                              value={AddCustom.Discount}
                              style={Adderror && !AddCustom.Discount ? { border: '1px solid red' }:{}}
                              onChange={e=>{SetDataValue(e.target.value,'Discount')}}
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  id="closeEditModal"
                  data-dismiss="modal"
                >
                  Close
                </button>
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={submitLoader}
                >
                  {submitLoader ? (
                    <i className="fas fa-spinner fa-spin"></i>
                  ) : (
                    "Add"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* ---------------- Add Modal End------------------ */}

      {/* ---------------- Edit Modal Start------------------ */}
      <div
        className="modal fade"
        id="EditModal"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="exampleModalLabel">
                Edit
              </h4>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={resetFunc}
              >
                {" "}
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form onSubmit={(e) => submit(e)}>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-6 col-12">
                    <div className="form-group">
                      <label>customSize</label>
                      <input
                        type="text"
                        name="name"
                        className="form-control"
                        value={customsize}
                        onChange={(e) => setcustomSize(e?.target?.value)}
                        placeholder="customSize"
                      />
                      {error && !customsize && (
                        <div className="error mt-1">customSize is required</div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6 col-12">
                    <div className="form-group">
                      <label>thin Gallery Wrap($)</label>
                      <input
                        type="text"
                        name="name"
                        className="form-control"
                        placeholder="thin Gallery Wrap"
                        value={thingallerywrap}
                        onChange={(e) => setthinGalleryWrap(e?.target?.value)}
                      />
                      {error && !thingallerywrap && (
                        <div className="error mt-1">
                          thin Gallery Wrap is required
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6 col-12">
                    <div className="form-group">
                      <label>thick Gallery Wrap($)</label>
                      <input
                        type="text"
                        name="name"
                        className="form-control"
                        placeholder="thick Gallery Wrap"
                        value={thickgallerywrap}
                        onChange={(e) => setthickGalleryWrap(e?.target?.value)}
                      />
                      {error && !thickgallerywrap && (
                        <div className="error mt-1">
                          thick Gallery Wrap is required
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6 col-12">
                    <div className="form-group">
                      <label>Framed($)</label>
                      <input
                        type="text"
                        name="name"
                        className="form-control"
                        placeholder="framed"
                        value={framed}
                        onChange={(e) => setFramed(e?.target?.value)}
                      />
                      {error && !framed && (
                        <div className="error mt-1">frame is required</div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6 col-12">
                    <div className="form-group">
                      <label>rolled in the Tude($)</label>
                      <input
                        type="text"
                        name="name"
                        className="form-control"
                        placeholder="rolled in the Tude"
                        value={floatingframe}
                        onChange={(e) => setfloatingframe(e?.target?.value)}
                      />
                      {error && !floatingframe && (
                        <div className="error mt-1">
                          rolled in the Tude is required
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6 col-12">
                    <div className="form-group">
                      <label>Discount</label>
                      <input
                        type="text"
                        name="name"
                        className="form-control"
                        placeholder="Discount"
                        value={discount}
                        onChange={(e) => setDiscount(e?.target?.value)}
                      />
                    </div>
                  </div>
                </div>
                {/* <div className="row">
                  <div className=" col-md-6 col-12">
                    <div className="form-group">
                      <label>Status</label>
                      <select
                        className="form-control"
                        onChange={(e) => setStatus(e?.target?.value)}
                        value={status}
                      >
                        <option value="" default hidden>
                          Select
                        </option>
                        <option value="Active">Active</option>
                        <option value="Inactive">Inactive</option>
                      </select>
                      {error && !status && (
                        <div className="error mt-1">Status is required</div>
                      )}
                    </div>
                  </div>
                </div> */}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  id="closeEditModal"
                  data-dismiss="modal"
                  onClick={resetFunc}
                >
                  Close
                </button>
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={submitLoader}
                >
                  {submitLoader ? (
                    <i className="fas fa-spinner fa-spin"></i>
                  ) : (
                    "Update"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* ---------------- Edit Modal End------------------ */}
    </div>
  );
}
